export default function PaymentSummary({ data, fee }) {
  return (
    <div className="container p-3">
      <h4 className="card-title text-center" id="plate_d">
        หมายเลขทะเบียน:{" "}
        <span id="plate">{data.entry_License ?? "ไม่สามารถระบุได้"}</span>
      </h4>
      <h5 className="text-center text-primary">ค่าบริการที่ต้องชำระ</h5>
      <h5 className="text-center text-primary">
        <span id="amount">
          {(fee.summ - fee.paid)?.toLocaleString("en-US", {
            // style: 'currency',
            currency: "USD",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </span>{" "}
        บาท
      </h5>
    </div>
  );
}
